import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import VueMeta from "vue-meta";
import { authGuard } from "./AuthGuard";
import { RouteNames } from "./RouteNames";
import { Roles } from "@/enums";

Vue.use(VueRouter);
Vue.use(VueMeta);

const routes: RouteConfig[] = [
    {
        path: "/",
        component: () =>
            import(
                /* webpackChunkName: "layout" */ "@/views/layout/Layout.vue"
            ),
        children: [
            {
                path: "/",
                name: RouteNames.home,
                component: () =>
                    import(/* webpackChunkName: "home" */ "@/views/Home.vue"),
            },
            {
                path: "/activations/new",
                name: RouteNames.createActivation,
                component: () =>
                    import(
                        /* webpackChunkName: "home" */ "@/views/activation/form/ActivationForm.vue"
                    ),
            },
            {
                path: "/activations/:id/edit",
                name: RouteNames.editActivation,
                component: () =>
                    import(
                        /* webpackChunkName: "home" */ "@/views/activation/form/ActivationForm.vue"
                    ),
            },
            {
                path: "/activations/:id/show",
                name: RouteNames.showActivation,
                component: () =>
                    import(
                        /* webpackChunkName: "showActivation" */ "@/views/activation/show/ActivationShow.vue"
                    ),
            },
            {
                path: "/calendar",
                name: RouteNames.calendar,
                component: () =>
                    import(
                        /* webpackChunkName: "calendar" */ "@/views/Home.vue"
                    ),
            },
            {
                path: "/requests/new",
                name: RouteNames.createRequest,
                component: () =>
                    import(
                        /* webpackChunkName: "newRequest" */ "@/views/Home.vue"
                    ),
            },
            {
                path: "/brands",
                name: RouteNames.brands,
                component: () =>
                    import(
                        /* webpackChunkName: "brands" */ "@/views/brands/brands/Brands.vue"
                    ),
                children: [
                    {
                        path: "/brands/new",
                        name: RouteNames.newBrand,
                        component: () =>
                            import(
                                /* webpackChunkName: "newBrand" */ "@/views/brands/newBrand/NewBrand.vue"
                            ),
                    },
                ],
            },
            {
                path: "/markets",
                name: RouteNames.markets,
                component: () =>
                    import(
                        /* webpackChunkName: "markets" */ "@/views/markets/markets/Markets.vue"
                    ),
                children: [
                    {
                        path: "/markets/new",
                        name: RouteNames.newMarket,
                        component: () =>
                            import(
                                /* webpackChunkName: "newMarket" */ "@/views/markets/newMarket/NewMarket.vue"
                            ),
                    },
                ],
            },
            {
                path: "/prAffiliates",
                name: RouteNames.prAffiliates,
                component: () =>
                    import(
                        /* webpackChunkName: "prAffiliates" */ "@/views/prAffiliates/prAffiliates/PrAffiliates.vue"
                    ),
                children: [
                    {
                        path: "/prAffiliates/new",
                        name: RouteNames.newPrAffiliate,
                        component: () =>
                            import(
                                /* webpackChunkName: "newPrAffiliate" */ "@/views/prAffiliates/newPrAffiliate/NewPrAffiliate.vue"
                            ),
                    },
                ],
            },
        ],
    },
    {
        path: "/auth",
        redirect: "/",
    },
    {
        path: "/unauthorized",
        name: RouteNames.unauthorized,
        component: () =>
            import(
                /* webpackChunkName: "unauthorized" */ "@/views/unauthorized/Unauthorized.vue"
            ),
    },
    {
        path: "*",
        name: RouteNames.notFound,
        component: () =>
            import(
                /* webpackChunkName: "notFound" */ "@/views/notFound/NotFound.vue"
            ),
    },
    {
        path: "/admin",
        component: (): any =>
            import(
                /* webpackChunkName: "layout" */ "@/views/layout/Layout.vue"
            ),
        children: [
            {
                path: "user",
                name: RouteNames.adminUser,
                component: (): any =>
                    import("@/views/admin/user/AdminUser.vue"),
            },
        ],
        meta: {
            requiresRoles: [Roles.Administrator],
        },
    },
];

const router = new VueRouter({
    mode: "history",
    routes,
});

router.beforeEach(authGuard);

export { router, RouteNames };
